<template>
  <v-dialog
    v-model="dialog"
    open-on-focus
    no-click-animation
    persistent
    max-width="290"
    content-class="select-date__dialog"
    transition="dialog-bottom-transition"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card>
      <v-date-picker
        v-model="selectedDate"
        no-title
        :min="currentDate"
      ></v-date-picker>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn rounded elevation="0" color="accent" text @click="dismissDialog">
          Cancel
        </v-btn>

        <v-btn
          rounded
          elevation="0"
          color="accent"
          @click="closeDialog(selectedDate)"
        >
          Apply
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SelectDateDialog',
  props: {
    date: {
      type: [Date, String],
      default: '',
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedDate: this.date,
      dialog: false,
      currentDate: new Date().toISOString().substring(0, 10),
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
      } else {
        this.dialog = false
      }
    },
  },
  methods: {
    dismissDialog() {
      this.dialog = false
      this.$emit('dismiss-dialog')
    },
    closeDialog(selectedDate) {
      this.dialog = false
      this.$emit('close-dialog', selectedDate)
    },
    onClickOutside() {
      this.dismissDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.dismissDialog()
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.select-date {
  &__dialog.v-dialog:not(.v-dialog--fullscreen) {
    bottom: 0 !important;
    right: 0 !important;
    position: absolute !important;
  }
}
</style>
